import * as React from "react";
const SvgFiRrBanner2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-banner-2_svg__a)">
      <path
        fill="#062147"
        d="M23.921 20.482C22.839 18.224 21 16.713 21 16.713s1.572-1.382 2.684-2.476c.465-.458.365-1.234-.213-1.536-.739-.385-2.026-.837-3.47-1.142V8.008c0-1.547-1.144-2.829-2.659-2.983A5 5 0 0 0 16.847 5c-2.802 0-4.114.992-5.384 1.951-.894.675-1.826 1.359-3.462 1.741v-.169a3 3 0 0 0-2.348-2.927c-1.245-.28-3.327-.673-4.633-1.128-.647-.226-1.237.458-.94 1.076 1.082 2.258 2.921 3.77 2.921 3.77S1.43 10.696.318 11.79c-.465.458-.365 1.234.213 1.536.739.385 2.026.837 3.47 1.142v2.525c0 1.547 1.144 2.829 2.659 2.983q.245.024.495.025c2.849 0 4.173-.929 5.453-1.828.89-.625 1.814-1.258 3.393-1.692v1.023a3 3 0 0 0 2.349 2.927c1.245.28 3.326.673 4.632 1.128.647.226 1.237-.458.941-1.077zm-12.463-3.947C10.246 17.386 9.371 18 7.154 18q-.147 0-.293-.016c-.482-.049-.861-.485-.861-.993v-6.017c3.703-.188 5.335-1.422 6.668-2.428 1.144-.864 2.047-1.547 4.178-1.547q.147 0 .293.016c.482.049.861.485.861.993v6.075c-3.607.391-5.223 1.526-6.542 2.452"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-banner-2_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBanner2;
